import React, { ReactElement } from 'react';
import { FormattedMessage } from '../../../utils/i18n';
import { userHasPermissionEnabled, PERMISSIONS } from '../../../utils/permissions';
import { PrimaryButton } from '../buttons';
import User from '@/types/user';
import GenericContact from '@/types/generic-contact';

type Props = {
  user: User;
  contact: GenericContact;
  onCreateRiskProfile: () => void;
};

export default function RiskProfileEmptyState(props: Props): ReactElement {
  const { contact, user, onCreateRiskProfile } = props;

  const canViewQuestionnaire = userHasPermissionEnabled(user, PERMISSIONS.RISK_QUESTIONNAIRE);
  const key = canViewQuestionnaire ? 'NoRiskProfiles' : 'NoRiskProfiles.NoQuestionnaire';

  return (
    <div className="risk-profile-empty-state d-flex flex-column align-content-center">
      <h1 data-private data-dd-privacy="mask">
        <FormattedMessage id={`EmptyState.${key}.Title`} values={{ name: contact.fname || contact.email }} />
      </h1>

      <span className="empty-text" data-private data-dd-privacy="mask">
        <FormattedMessage id={`EmptyState.${key}.Text`} />
      </span>

      <div className="d-flex justify-content-center">
        <PrimaryButton onClick={() => onCreateRiskProfile()}>
          <FormattedMessage id={`EmptyState.${key}.GetStarted`} />
        </PrimaryButton>
      </div>
    </div>
  );
}
